﻿import { createApp } from 'vue';
import VueCustomViviendasCatalogoComponent from '../../Components/vue-custom-viviendas-catalogo-component.vue';

createApp({
    components: {
        VueCustomViviendasCatalogoComponent
    }
}).mount('#app');

